import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import ServeCoachChat from "./ServeCoachChat";
import "./App.css";

export default function CxChatPage() {
  const [searchParams] = useSearchParams();
  const videoId = searchParams.get("video_id");

  return (
    <main className="app-shell">
      <header className="topbar">
        <Link className="wordmark" to="/"><span className="wordmark-icon">🎾</span><span>Evolve <span className="wordmark-accent">Sports</span></span></Link>
        <Link className="button button-quiet" to={videoId ? `/feedback?video_id=${encodeURIComponent(videoId)}` : "/library"}>Back to analysis</Link>
      </header>
      <div className="coach-chat-page">
        <section className="coach-chat-intro">
          <p className="eyebrow">YOUR AI SERVE COACH</p>
          <h1>Turn feedback into your next best rep.</h1>
          <p className="hero-copy">Ask a question and get a concise answer grounded in your latest completed serve analysis.</p>
          <div className="coach-context"><span>◎</span>{videoId ? "Coaching on your selected serve" : "Coaching on your latest completed serve"}</div>
        </section>
        <ServeCoachChat videoId={videoId} />
      </div>
    </main>
  );
}
